<template>
  <form class="t-sign-up" @submit.stop.prevent="Submit()">
    <h2>{{ signUp.enrollTitle }}</h2>
    <div class="t-input t-input_checkbox-small" v-if="course.type !== 3">
      <label>{{ form.title }}</label>

      <template v-if="lesson_in_day.length > 1">
        <div v-for="(item, index) in lesson_in_day" :key="index">
          <input class="t-radio" type="radio" v-model="form.value" :value="item.id" :id="'time_' + index" :onclick="SelectDate(index)">
          <label :for="'time_' + index">{{ item.time }}</label>
        </div>
      </template>
      <template v-else>
        <p>{{ lesson_in_day[0].time }}</p>
      </template>
    </div>
    <div class="t-input" v-else>
      <label>{{ form.title }}</label>
      <p>{{ signUp.firstLesson }} {{ lesson_in_day[0].time }}</p>
    </div>
    <button class="t-btn" :class="{_disabled: (form.value <= 0 && lesson_in_day.length > 1) || disabledBtn}"><span>{{ signUp.enrollBtn }} {{ course.price }} ₽</span></button>
    <button class="t-btn t-btn_white" @click.prevent="modalDialogClose()"><span>{{ signUp.setNewDate }}</span></button>
  </form>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';
    import {store} from '../../store'

    export default {
        data(){
            return {
                timeout: 30,
                disabledBtn: false,
                month: store.getters['calendar/calendarText'].month_2,
                date: null,
                form: {
                    title: '',
                    value: -1
                }
            }
        },
        computed: {
            ...mapGetters('staticText', ['signUp', 'balanceText']),
            ...mapGetters('coursesList', ['course', 'streams', 'stream_id']),
            lesson_in_day(){
                this.form.title = '';

                let les = [];

                if(this.course.type !== 3){
                    for(let s = 0; s < this.streams.length; s++){
                        let stream = this.streams[s];
                        if(stream.choose){
                            if(this.stream_id.indexOf(stream.id) >= 0){
                                let time = '';

                                let date = new Date(stream.lessons[0].date_time);
                                this.date = date;

                                let hours = date.getHours();
                                let minutes = date.getMinutes();

                                let time_start = [];
                                time_start.push(hours < 10 ? '0' + hours : hours);
                                time_start.push(minutes < 10 ? '0' + minutes : minutes);

                                time += time_start.join(':');

                                minutes = (hours * 60) + minutes + stream.lessons[0].duration;
                                hours = Math.floor(minutes / 60);
                                minutes = minutes - hours * 60;
                                if(hours < 10)
                                    hours = '0' + hours;
                                if(minutes < 10)
                                    minutes = '0' + minutes;
                                time += '-' + hours + ':' + minutes;

                                les.push(
                                    {
                                        id: stream.id,
                                        time: time
                                    }
                                );

                                if(this.form.title === ''){
                                    this.form.title = date.getDate() + ' ' + this.month[date.getMonth()];
                                }
                            }
                        }
                    }
                } else{
                    for(let s = 0; s < this.streams.length; s++){
                        let stream = this.streams[s];
                        if(stream.choose) {
                            if (this.stream_id.indexOf(stream.id) >= 0) {
                                let time = '';

                                let date = new Date(stream.lessons[0].date_time);

                                let hours = date.getHours();
                                let minutes = date.getMinutes();

                                let time_start = [];
                                time_start.push(hours < 10 ? '0' + hours : hours);
                                time_start.push(minutes < 10 ? '0' + minutes : minutes);

                                time += time_start.join(':');

                                les.push(
                                    {
                                        id: stream.id,
                                        time: time
                                    }
                                );

                                if (this.form.title === '') {
                                    let date_last = new Date(stream.lessons[stream.lessons.length - 1].date_time);

                                    this.form.title = date.getDate() + ' ' + this.month[date.getMonth()] + ' - ' + date_last.getDate() + ' ' + this.month[date_last.getMonth()];
                                }
                            }
                        }
                    }
                }

                return les;
            }
        },
        methods: {
            ...mapActions('modal', ['modalDialogClose', 'modalDialogType_refillOpen']),
            ...mapActions('msg', ['showMsg']),
            ...mapActions('coursesList',['LoadStreams']),
            Submit(){
                this.disabledBtn = true;

                if(this.lesson_in_day.length > 1){
                    if(this.form.value === -1){
                        this.showMsg(this.signUp.msgSetTime);
                    } else{
                        let fd = new FormData();

                        fd.append('id', this.course.id);
                        fd.append('stream', this.form.value);
                        this.$http.post('sign_up', fd)
                            .then(response => response.json())
                            .then(data => {
                                if(data.success){
                                    this.disabledBtn = false;

                                    this.modalDialogClose();
                                    this.showMsg(this.signUp.applicationSubmitted);

                                    let date = new Date();

                                    let start = date.getFullYear() + '.' + (date.getMonth() + 1) + '.1';
                                    let end = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.daysInMonth();

                                    this.LoadStreams({start: start, end: end, id: this.course.id});
                                } else{
                                    this.modalDialogClose();
                                    let error = '';
                                    for(let key in data.errors){
                                        let text = data.errors[key].join(', ');
                                        error += text;
                                    }
                                    if (data.modal == 'noMoney') {
                                      this.modalDialogType_refillOpen({course: this.course});
                                    } else {
                                      this.showMsg(error);
                                    }
                                }
                            })
                    }
                } else{
                    let fd = new FormData();

                    fd.append('id', this.course.id);
                    fd.append('stream', this.lesson_in_day[0].id);

                    this.$http.post('sign_up', fd)
                        .then(response => response.json())
                        .then(data => {
                            if(data.success){
                                this.disabledBtn = false;

                                this.modalDialogClose();
                                this.showMsg(this.signUp.applicationSubmitted);

                                let date = new Date();

                                let start = date.getFullYear() + '.' + (date.getMonth() + 1) + '.1';
                                let end = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.daysInMonth();

                                this.LoadStreams({start: start, end: end, id: this.course.id});
                            } else{
                                this.modalDialogClose();
                                let error = '';
                                for(let key in data.errors){
                                    let text = data.errors[key].join(', ');
                                    error += text;
                                }

                                if (data.modal == 'noMoney') {
                                  this.modalDialogType_refillOpen({course: this.course});
                                } else {
                                  this.showMsg(error);
                                }
                            }
                        })
                }
            },
            SelectDate(index) {
                if (this.form.value !== -1 && this.lesson_in_day[index] && this.form.value === this.lesson_in_day[index]['id']) {
                    let time = this.lesson_in_day[index]['time'].split('-')[0];
                    let date = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), time.split(':')[0], time.split(':')[1]);
                    let curr = new Date();
                    let res = Math.floor((date - curr) / 1000 / 60);
                    this.disabledBtn = !(res > this.course.timeOuts.min_create_query);
                }
            }
        }
    }
</script>

<style lang="sass">
.t-sign-up
  width: 320px
  padding: 24px
  @extend %substrate
</style>



// WEBPACK FOOTER //
// src/vue_components/ModalDialog/SignUp.vue